<template>
  <div>
    <Row>
      <Col span="24">
        <div style="padding: 20px">
          <div
            class="editor-wrapper">
            <div
              class="editor"
              contenteditable="true"
              v-text="innerContent"
              @input="sync"
              >
            </div>
          </div>
        </div>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <div style="padding: 20px">
          <pre style="background-color: #eee"><code>{{ content }}</code></pre>
        </div>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <div style="padding: 20px">
          <p>文字数: {{ amount }}</p>
          <p>最長行: {{ count }}</p>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: "hello",
      innerContent: ""
    }
  },
  methods: {
    sync(e) {
      this.content = e.target.innerHTML.replace(/<br>/g, '\n')
    }
  },
  computed: {
    amount() {
      return this.content.replace(/\n/, '').length
    },
    count() {
      return Math.max(...this.content.split('\n').map(i => i.length))
    }
  },
  mounted() {
    this.innerContent = this.content
  }
}
</script>

<style>
.editor-wrapper {
  width: 1001px;
  background-image: url("../assets/img/bg.svg");
  border-top: 1px solid #dedede;
  border-left: 1px solid #dedede;
}
.editor {
  width: 100%;
  min-height: 40px;
  margin-left: 3px;
  font-feature-settings: 'fwid';
  display: inline-block;
  font-size: 14px;
  letter-spacing: 6px;
  line-height: 20px;
  word-break: break-all;
  overflow-wrap: anywhere;
}

.editor:read-write:focus {
  outline: none;
}
</style>
